import { useCallback } from "react";

export const useScrollLock = () => {
  const lockScroll = useCallback(() => {
    document.body.style.overflow = "hidden";
    document.body.style.overscrollBehavior = "contain";
  }, []);

  const unlockScroll = useCallback(() => {
    document.body.style.overflow = "";
    document.body.style.overscrollBehavior = "";
  }, []);

  return {
    lockScroll,
    unlockScroll,
  };
};
